import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router'
import { App } from './App'
import { ErrorBoundary } from './components/ErrorBoundary'
import { initObservability } from './lib/observability'
import { applyAppManifest } from './lib/documentBranding'
import { envValue } from './lib/env'
import { bootBrandSlug, readRememberedTenantSlug } from './lib/publicBranding'
import './index.css'

// Installed before the first render so a crash during initial mount is caught
// too — that is the one that leaves a genuinely blank page.
initObservability()

// The app's only manifest link, added before the first render: index.html carries
// none, so the first manifest Chrome reads is this tenant's, not the platform's.
applyAppManifest(
  bootBrandSlug(
    window.location.pathname,
    window.location.search,
    readRememberedTenantSlug(),
    envValue(process.env.EXPO_PUBLIC_TENANT_SLUG) ?? null,
  ),
)

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    {/* Outside BrowserRouter on purpose: a crash in a layout or a lazy route
        chunk unmounts the router itself, and a boundary inside it goes with it. */}
    <ErrorBoundary source="app">
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ErrorBoundary>
  </StrictMode>,
)
